import { useEffect } from "react";

const DEFAULT_OG_IMAGE = "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=70";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

function removeJsonLd(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

/**
 * useSeo — sets <title>, meta description, OG/Twitter tags + optional JSON-LD.
 * Call from each page once at the top of the component.
 */
export function useSeo({ title, description, path = "/", jsonLd = null, image = DEFAULT_OG_IMAGE }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · RentAnything.ai` : "RentAnything.ai — Booking software flexible enough to rent anything";
    document.title = fullTitle;
    setMeta("description", description);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", `https://rentanything.ai${path}`, "property");
    setMeta("og:image", image, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", description);
    setMeta("twitter:image", image);

    if (jsonLd) {
      setJsonLd("page-jsonld", jsonLd);
    } else {
      removeJsonLd("page-jsonld");
    }

    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image]);
}
